<template lang='pug'>
  i.svg-icon.svg-icon-like
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d='M89,43.4c0,0.9,0,1.8,0,2.8c-0.7,2.1-1.5,4.3-2.2,6.4c-0.1,0.2,0,0.5,0,0.8c0.4,3,0.1,5.9-1.1,8.6c-0.3,0.6-0.4,1.3-0.4,2 c0.1,3.1-0.6,5.9-2.1,8.6c-0.4,0.8-0.8,1.7-0.9,2.6C81.8,82.3,77,87.5,70,88.7c-0.9,0.2-1.9,0.3-2.8,0.4c-2.9,0-5.8,0-8.7,0 c-1.5-0.2-3-0.2-4.5-0.6c-4.9-1.3-9.8-2.6-14.6-4.1c-3.1-1-6.1-1.7-9.3-1.6c-3.3,0.2-6.7,0-10,0c-3.3,0-6.2-2.3-7.1-5.5 c-0.2-0.5-0.3-1.1-0.4-1.6c0-10.5,0-21,0-31.5c0.1-0.1,0.2-0.3,0.2-0.4c0.7-4.2,3.6-6.7,7.8-6.7c3.3,0,6.5-0.1,9.8,0.1 c2,0.1,3.4-0.6,4.6-2.1c2.7-3.5,5.6-6.9,8.4-10.3c1-1.2,1.6-2.4,2-3.9c0.5-2.4,1-4.8,1.8-7.1c1.7-5.2,5-7.5,10.2-7.2 C63.3,7,68,10.4,69.6,16c1.4,4.7,1.4,9.4-0.2,14.1c-0.1,0.3-0.1,0.5-0.2,0.9c2.1,0,4.1,0,6.1,0c6.1,0,11.6,4.2,13.2,10 C88.7,41.8,88.8,42.6,89,43.4z M74.7,49.5c1.1-0.1,1.9-0.1,2.7-0.1c0.4,0,0.8-0.1,1-0.4c1.2-1.8,2-3.7,1.2-5.9 c-0.7-1.9-2.6-3-4.8-3c-5.4,0-10.9,0-16.3,0c-0.4,0-0.9,0-1.4,0c0-0.4-0.1-0.6-0.1-0.8c-0.2-3.2,1.1-6,2.3-8.8 c0.7-1.7,1.5-3.5,1.9-5.3c0.6-2.6,0.4-5.2-0.8-7.6c-0.6-1.2-2.9-2.4-4.1-1.9c-0.7,0.3-0.9,1.6-1.4,2.4c-0.1,0.1,0,0.3-0.1,0.5 c-1,5.1-2.4,10-6.3,13.9c-2.7,2.7-4.8,6-7.3,8.8c-2,2.3-4.1,4.7-7.5,5c0,9.3,0,18.4,0,27.2c3.3,1,6.4,1.8,9.4,2.9 c7.6,2.9,15.5,4.1,23.6,3.6c4.6-0.3,6.8-2.7,6.4-7.3c-0.1-0.6-0.2-1.3-0.2-1.9c0-0.3,0.2-0.8,0.5-1c2.6-1.8,3.4-4.8,1.9-7.6c-0.2-0.3-0.3-0.6-0.5-0.9c1.8-1.6,3-3.3,2.8-5.8C77.9,53,76.4,51.3,74.7,49.5z')


</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>